import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import urlJoin from 'url-join';
import { Button, Modal, ModalContent } from '@clearcover/atlas';
import { useAppContext } from 'QuoteApp/services/providers';
import { QUOTE_APP_ROUTE } from 'Shared/constants/routes';

type CoverageUpdateModalType = {
  open: boolean;
  redirectToSummary?: boolean;
};

export const CoverageUpdateModal: React.FC<CoverageUpdateModalType> = ({
  open,
  redirectToSummary = false,
}) => {
  const {
    appId,
    refreshRate,
    refreshConfig,
    acknowledgeQuoteChange,
  } = useAppContext();
  const history = useHistory();

  const handleClose = useCallback(() => {
    acknowledgeQuoteChange();

    if (redirectToSummary) {
      history.push(urlJoin(QUOTE_APP_ROUTE, appId, 'summary'));
    }
  }, [acknowledgeQuoteChange, redirectToSummary, history, appId]);

  useEffect(() => {
    if (open) {
      refreshConfig();
      refreshRate();
    }
    // Only call when opened, disregard `refreshRate` and `refreshConfig` reference changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal
      open={open}
      controlled
      variant="tall"
      handleClose={handleClose}
      showCloseIcon={false}
    >
      {closeModal => (
        <ModalContent style={{ padding: '32px' }}>
          <h2>The quote has been updated and requires your review.</h2>
          <p>
            In order to generate a tailored quote, the provided responses are
            combined with vehicle and driving data. Changes in the quote and
            coverage availability may have occurred based on updated information
            or reports. Please review any remaining questions before proceeding
            to checkout.
          </p>
          <Button variant="primary" block onClick={() => closeModal()}>
            Review new quote
          </Button>
        </ModalContent>
      )}
    </Modal>
  );
};
